import { z } from 'zod'
import * as http from '@/util/http'

export const PersonalInfoSchema = z.object({
  email: z.email(),
  firstName: z.string().min(1, '必須項目です'),
  firstNameFurigana: z
    .string()
    .min(1, '必須項目です')
    .regex(/^[\u30A0-\u30FFー\s]+$/, '正しいひらがなを入力してください'),
  lastName: z.string().min(1, 'required'),
  lastNameFurigana: z
    .string()
    .min(1, '必須項目です')
    .regex(/^[\u30A0-\u30FFー\s]+$/, '正しいひらがなを入力してください'),
  birthdate: z.coerce.date({ error: '正しい日付を入力してください' }),
  /*
  phoneNumber: z
    .string()
    .regex(
      /^(\+?\d{1,3})?0?\d{9,10}$/,
      'Invalid phone number format (e.g. 09012345678 or +819012345678)'
    ),
  */
})

export type PersonalInfoForm = z.input<typeof PersonalInfoSchema>

export const DEFAULT_PERSONAL_INFO: PersonalInfoForm = {
  email: '',
  firstName: '',
  firstNameFurigana: '',
  lastName: '',
  lastNameFurigana: '',
  birthdate: '',
}

export async function fetchUserData(): Promise<PersonalInfoForm> {
  const { data } = await http.get<PersonalInfoForm>('/api/v1/user')
  return data
}

export async function saveUserData(payload: PersonalInfoForm) {
  return http.put('/api/v1/user', { payload })
}
